import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaArrowRight } from 'react-icons/fa';
import './AdminSignIn.css';
// --- CHANGE: Import Logo ---
import logo from '../../assets/sk-tt-logo.png'; 

export default function AdminSignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const API_BASE_URL =process.env.REACT_APP_API_BASE_URL ;
      const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      let data = null;
      try { data = await res.json(); } catch (e) { /* non-json response */ }
      if (res.ok && data && data.success) {
        localStorage.setItem('adminToken', data.token);
        navigate('/admin/add-slider');
      } else if (data && data.message) {
        setError(data.message);
      } else {
        setError('Incorrect email or password');
      }
    } catch (err) {
      setError('Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-signin-page">
      <div className="admin-signin-card">
        
        {/* --- Logo Section --- */}
        <div className="admin-signin-logo-container">
            <img src={logo} alt="SK College Logo" className="admin-signin-logo" />
        </div>

        <div className="admin-signin-header">
            <h2>Admin Login</h2>
            <p>Welcome back! Please sign in to your account.</p>
        </div>

        <form onSubmit={submit}>
            {/* Email Input */}
            <div className="admin-signin-input-wrapper">
                <FaUser className="admin-signin-icon" />
                <input
                    className="admin-signin-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email Address"
                    required
                />
            </div>

            {/* Password Input */}
            <div className="admin-signin-input-wrapper">
                <FaLock className="admin-signin-icon" />
                <input
                    className="admin-signin-input"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                />
                <button 
                    type="button" 
                    className="admin-signin-eye-btn" 
                    onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
            </div>

            {error && <div className="admin-signin-error">{error}</div>}

            <button className="admin-signin-submit-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : (
                <>
                  <span className="btn-text">Sign In</span> <FaArrowRight /> 
                </>
              )}
            </button>
        </form>
      </div>
    </div>
  );
}